module.exports = __webpack_public_path__ + "img/2.ca6fd7c4.jpg";